<template>
	<div class="row clearfix" :style="stylerow">
		<div class="classify-title">{{searchname}}</div>
		<div class="classify-list" :style="style">
			<span :class="getClass(0,currentkey)">
                              <a @click="search(0,'')" >全部</a>
                            </span>
			<span :class="getClass((index+1),currentkey)" v-for="(item,index) in searchkeyop " :key="(index+1)" v-if="searchby=='bookVersionId'">
                              <a @click="search((index+1),item.bookVersionId)" >{{item.bookVersionName}}</a>
                            </span>
			<span :class="getClass((index+1),currentkey)" v-for="(item,index) in searchkeyop " :key="(index+1)" v-if="searchby=='courseId'">
                              <a @click="search((index+1),item.id)" >{{item.courseName}}</a>
                            </span>
			<span :class="getClass((index+1),currentkey)" v-for="(item,index) in searchkeyop " :key="(index+1)" v-if="searchby!='bookVersionId'&&searchby!='courseId'">
                              <a @click="search((index+1),item.configValue)" >{{item.configName}}</a>
                            </span>

		</div>
		<div style="clear:both;"></div>
	</div>
</template>

<script>
	export default {
		props: {
			searchname: {
				type: String,
				default: ''
			},
			searchkeys: {
				type: Array,
				default: function () {
					return []
				}
			},
			searchby: {
				type: String,
				default: '年级'
			},
			current: {
				type: Number,
				default: 0
			},
			styleop: {
				type: String,
				default: "width:1090px;"
			},
			stylerowop: {
				type: String,
				default: "width:100%;"
			},
		},
		watch: {
			searchkeys(val) {
				this.searchkeyop = this.searchkeys;
			},
			current(val, oldVal) {				    
					this.currentkey = val;
					if(val == 0) {
						this.$emit('input', "");
					} else {

						if(this.searchby == 'gradeId,bookId') {
							let key = this.searchkeyop[val - 1].configValue.split('_');
							this.$emit('input', 'gradeId=' + key[0] + '&bookId=' + key[1]);

						} else {
							if(this.searchby != 'bookVersionId') {
								this.$emit('input', this.searchby + '=' + this.searchkeyop[val - 1].configValue);

							} else {

								this.$emit('input', this.searchby + '=' + this.searchkeyop[val - 1].bookVersionId);

							}
						}
					}
				
			}
		},
		data: function() {
			return {
				style: this.styleop,
				searchkeyop: [],
				stylerow: this.stylerowop,
				currentkey: this.current

			}
		},
		methods: {
			// 根据状态，设置样式
			getClass(index, current) {
				let classStr = index === current ? 'classify-item active' : 'classify-item';
				return classStr;
			},
			search(index, key) {
				this.currentkey = index;
				if(key == '') {
					this.$emit('input', "");
					if(this.searchby == 'gradeId,bookId') {						
						this.$emit('searchversion');
					} else {						
						if(this.searchby == 'courseId') {
							this.$emit('searchversion');
						}
						if(this.searchby == 'bookVersionId') {
							this.$emit('getBookVersion','');
						}
					}
				} else {
					if(this.searchby == 'gradeId,bookId') {
						key = key.split('_');
						this.$emit('input', 'gradeId=' + key[0] + '&bookId=' + key[1]);
						this.$emit('searchversion');
					} else {
						this.$emit('input', this.searchby + '=' + key);
						if(this.searchby == 'courseId') {
							this.$emit('searchversion');
						}
						if(this.searchby == 'bookVersionId') {
							this.$emit('getBookVersion',key);
						}
					}

				}
				this.$emit('callbackload');
			}

		},
		mounted() {

		}
	};
</script>

<style type="text/css" lang="scss" rel="stylesheet/scss">
	.row {
		width: 100%;
		text-indent: 1em;
		font-size: 14px;
		height: auto;
		color: #666666;
		font-weight: normal;
		
		border-top: none;
		display: block;
		.classify-title {
			float: left;
			color: #333333;
			line-height: 55px;
		}
		.classify-list {
			float: left;
			width: 1050px;
			.classify-item {
				cursor: pointer;
				float: left;
				line-height: 55px;
				a {
					font-size: 14px;
					line-height: 24px;
					color: #666666;
					font-weight: normal;
					text-decoration: none;
					padding: 5px;
				}
			}
			.classify-item.active {
				a {
					color: white;
					background: #33CCCC;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/classify-item/index.vue